import { ListingCorpsDeMeuble } from '@components/listing-corps-de-meuble/models';
import { videoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const listingCorpsDeMeubleMock: Block<ListingCorpsDeMeuble> = {
  type: 'listing-corps-de-meuble',
  data: {
    breathingVideo: videoMock(),
    breathingText: 'Nos meubles sont fabriqués en France, garantis 10 ans et livrés chez vous [[déjà montés]]',
  },
};
